import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { TimeAdjustmentsStyled } from "./time-adjustments.styles";
import {
  getAllAppointmentsTypes,
  getAllTimeAdjustments,
  updateTimeAdjustment,
} from "../../../../actions";
import { Button } from "../../../../components/button/button";
import TextInputFormField from "../../../../components/form-fields/text-input-field/text-input-form-field";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { timeAdjustmentSchema } from "../../../../utils/validations";
import { addNotification } from "../../../../store/slices/ui-slice";
import { v4 as uuid } from "uuid";
import { useAppDispatch } from "../../../../store/hooks";
import Loader from "../../../../components/loader/loader";
import OverflowText from "../../../../components/overflow-text/overflow-text";

// interface AppointmentType {
//   label: string;
//   value: string;
// }

// interface TimeAdjustment {
//   data: {
//     id: string;
//   name: string;
//   routing_time?: number;
//   }
// }

interface FormData {
  [key: string]: string | number;
}

const TimeAdjustments: React.FC = () => {
  const [appointmentTypes, setAppointmentTypes] = useState<any[]>([]);
  const [validationSchema, setValidationSchema] = useState(() =>
    timeAdjustmentSchema(appointmentTypes)
  );
  const [timeAdjustmentData, setTimeAdjustmentData] = useState<any>([]);

  const {
    control,
    handleSubmit,
    formState: { isValid, isDirty },
  } = useForm<FormData>({
    resolver: yupResolver(validationSchema),
    mode: "all",
  });

  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [timeAdjustmentsResponse, appointmentTypesResponse] =
          await Promise.all([
            getAllTimeAdjustments(),
            getAllAppointmentsTypes(),
          ]);

        if (timeAdjustmentsResponse.data)
          setTimeAdjustmentData(timeAdjustmentsResponse.data.data);
        if (appointmentTypesResponse.data) {
          setAppointmentTypes(appointmentTypesResponse.data.data);
          setValidationSchema(
            timeAdjustmentSchema(appointmentTypesResponse.data.data)
          );
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: "Failed to fetch data",
          })
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  const onSubmit = async (data: FormData) => {
    const payload = {
      ...timeAdjustmentData,
      data: appointmentTypes?.map((x) => {
        return {
          id: x?.integration_id,
          name: x?.label,
          routing_time: data[x?.integration_id],
        };
      }),
    };

    if (payload?.created_at) delete payload?.created_at;
    if (payload?.updated_at) delete payload?.updated_at;

    setSubmitting(true);
    try {
      // if (timeAdjustmentData.length > 0)
      await updateTimeAdjustment(payload);
      // else await createTimeAdjustment(payload);
      dispatch(
        addNotification({
          id: uuid(),
          type: "success",
          message: "Time adjustment saved successfully!",
        })
      );
    } catch (error: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message:
            error.response?.data?.message || "Failed to save time adjustment",
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Loader absolute />;
  return (
    <TimeAdjustmentsStyled>
      <Box className="header">
        <Typography variant="h2">Time Adjustments</Typography>
        <div className="time-card-wrapper">
          <Box className="card-wrapper">
            <div className="content-wrapper">
              <Typography variant="h4">Routing Time</Typography>
              <div className="fields-wrapper">
                {appointmentTypes.map((appointmentType) => (
                  <TextInputFormField
                    key={appointmentType.integration_id}
                    name={appointmentType.integration_id}
                    control={control}
                    label={
                      <OverflowText maxWidth={200}>
                        {appointmentType.label}
                      </OverflowText>
                    }
                    inputType="number"
                    defaultValue={
                      timeAdjustmentData?.data?.find(
                        (x: any) => x.id === appointmentType.integration_id
                      )?.routing_time
                    }
                    placeholder="Please Enter"
                  />
                ))}
                {/* <TextInputFormField
                  name="wellness_visits_per_day"
                  inputType="number"
                  control={control}
                  label="Wellness Visits per day"
                  // defaultValue={
                  //   timeAdjustmentData.find((x) => x.key === "Wellness")
                  //     ?.wellness_visits_per_day
                  // }
                  placeholder="Please Enter"
                /> */}
              </div>

              <div className="button-wrapper">
                <Button
                  disabled={!isValid || !isDirty || submitting}
                  isLoading={submitting}
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSubmit(onSubmit)}
                >
                  {timeAdjustmentData.length > 0 ? "Update" : "Save"} changes
                </Button>
              </div>
            </div>
          </Box>
        </div>
      </Box>
    </TimeAdjustmentsStyled>
  );
};

export default TimeAdjustments;
